(function () {
  'use strict';

  angular.module('ringbaPortal').component('confirmationModal', {
    transclude: true,
    bindings: {
      onConfirm: '&',
      onCancel: '&',
      onCheckboxChange: '&',
      confirmText: '@',
      cancelText: '@',
      checkboxText: '@',
      modalTitle: '@',
      hideActions: '<',
      hideCancelButton: '<',
      showCheckbox: '<'
    },
    controller: ConfirmationModalController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/confirmation-modal/confirmation-modal.view.html'
  });

  function ConfirmationModalController() {
    'ngInject';
  }
})();
